<template>
    <v-form ref="form" @submit="submit" v-model="formValid">
        <div class="title-config">
            <div class="title">{{ $f.tc('dataMemoryMapping') }}</div>
            <div style="display: flex; align-items: center">
                <div class="btn-outline" @click="addItem()">
                    <img src="/img/add-blue.svg" alt="icon-add-mapping"
                         style="margin-right: 6px; transform: scale(1.1)">
                    {{ $t('addNew') | capitalize }}
                </div>
<!--                <div class="btn-outline" @click="importDataMapping">-->
<!--                    <img src="/img/add-blue.svg" alt="icon-add-mapping-excel"-->
<!--                         style="margin-right: 6px; transform: scale(1.1)">-->
<!--                    {{ $t('addNewExcel') | capitalize }}-->
<!--                </div>-->
<!--                <input type="file" :hidden="true" ref="inputDataMapping" accept=".xlsx, .xls, .csv"-->
<!--                       @change="handleFile">-->
<!--                <div class="btn-outline" style="width: 32px" @click="downloadTemplate"-->
<!--                     :title="$f.tc('downloadTemplateExcel')">-->
<!--                    <img src="/img/scenario/download_blue.svg" alt="icon-download-template">-->
<!--                </div>-->
                <div class="btn-custom" @click="submit">{{ $f.tc('save') }}</div>
            </div>
        </div>
        <div class="fci-scrollbar config-content">
            <div style="text-align: center; font-size: 14px; color: #96ADD0" v-if="itemList.length === 0">
                {{ $f.tc('noDataAvailable') }}
            </div>
            <div v-else>
                <div class="row-config" style="margin-bottom: 6px">
                    <div class="config-key" style="font-weight: 700; font-size: 14px;">{{
                            $f.tc('dataCollection')
                        }}
                    </div>
                    <div class="config-value" style="font-weight: 700; font-size: 14px;">{{
                            $f.tc('customerProperties')
                        }}
                    </div>
                    <div class="config-action"></div>
                </div>
                <div class="row-config" v-for="(item, index) in itemList" :key="`data_memory_mapping_${index}`"
                     style="margin-bottom: 6px">
                    <div class="config-key">
                        <v-text-field
                            v-model="itemList[index].data_collection"
                            :rules="formRules.required"
                            class="input-custom"
                            :placeholder="$f.tc('dataCollection')"
                        ></v-text-field>
                    </div>
                    <div class="config-value">
                        <v-text-field
                            v-model="itemList[index].customer_property"
                            :rules="formRules.required"
                            class="input-custom"
                            :placeholder="$f.tc('customerProperty')"
                        ></v-text-field>
                    </div>
                    <div class="config-action">
                        <div class="btn-icon" @click="removeItem(index)">
                            <img src="/img/delete-blue.svg" alt="icon-delete-mapping"
                                 style="transform: scale(1.2); padding-left: 1px">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-form>
</template>

<script>
import CampaignService from "@/services/campaign.service";
import BaseConfig from "@/views/Campaign/Form/Step4/BaseConfig";

export default {
    name: "DataMemoryMapping",
    extends: BaseConfig,
    data() {
        return {
            emptyItem: {
                data_collection: '',
                customer_property: ''
            },
            file: '',
        }
    },
    computed: {
        itemTranslate() {
            return this.$t('mailReport')
        },
    },
    methods: {
        removeItem(index) {
            this.itemList.splice(index, 1)
        },
        getCollectionData() {
            let obj = {}
            if (this.itemList.length) {
                let data = this.itemList
                for (let i = 0; i < data.length; i++) {
                    obj[data[i]['data_collection'].trim()] = data[i]['customer_property'].trim()
                }
            }
            return JSON.stringify(obj)
        },
        submitValidForm() {
            this.$store.dispatch(this.$actionTypes.campaign.UPDATE_CAMPAIGN, {
                campaign: this.campaign,
                model: {
                    data_memory_mapping: this.getCollectionData()
                }
            })
        },
        importDataMapping() {
            this.$refs.inputDataMapping.click()
        },
        handleFile(event) {
            this.file = event.target.files[0]
            let extFile = this.file.name.split('.').pop()
            if (this.file.size <= 1024 * 1024 && ['xlsx', 'csv', 'xls'].includes(extFile)) {
                let formData = new FormData()
                formData.append('file', this.file)
                this.$appService.showLoading()
                this.$http.post(
                    `/campaigns/${this.campaign.id}/import-data-mapping/`,
                    formData,
                    {headers: {'Content-Type': 'multipart/form-data'}}
                ).then(
                    res => {
                        this.$store.dispatch(this.$actionTypes.campaign.UPDATE_CAMPAIGN, {
                            campaign: this.campaign,
                            model: {
                                data_collection_mapping: JSON.stringify(res.data)
                            }
                        })
                    }
                ).catch(
                    err => {
                        this.$appService.toastError(err)
                    }
                ).finally(() => {
                    this.$appService.hideLoading()
                    this.file = null
                    this.$refs.inputDataMapping.value = null
                })

            } else {
                this.$appService.toastError('invalid file')
            }
        },
        downloadTemplate() {
            CampaignService.getDataMappingTemplate(this.campaign).then(res => {
                this.$utils.saveFile(res.data, this.$filters.replaceSpecialCharacters(this.$utils.nonAccentVietnamese(this.campaign.title + ' - data mapping template')), '.xlsx')
            })
        },
    },
    watch: {
        campaign: {
            immediate: true,
            handler: function (campaign) {
                if (campaign && campaign.id) {
                    let data = campaign.data_memory_mapping
                    if (data !== '') {
                        let obj = JSON.parse(data)
                        let arr = []
                        for (let k in obj) {
                            if (obj.hasOwnProperty(k)) {
                                arr.push({
                                    data_collection: k.toString(),
                                    customer_property: obj[k].toString()
                                })
                            }
                        }
                        this.itemList = arr
                    }
                }
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.title-config {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 20px;
    border-bottom: 1px solid #E4EDFA;
}

.btn-outline {
    margin-right: 8px;
}

.row-config {
    display: flex;
    align-items: center;

    .config-key, .config-value {
        width: 317px;
        margin-right: 8px;
    }

    .config-action {
        width: 32px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    &:last-child {
        padding-bottom: 20px;
    }
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.btn-icon {
    height: 32px;
    width: 32px;
}

.config-content {
    padding: 20px;
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 10px;
    }
}
</style>
